import React from "react";

export default function IndexSectionFeatures10() {
  return (
    <React.Fragment>
      <>
        <section className="relative pt-24 pb-24 md:pb-20 lg:pt-32 overflow-hidden">
          <img
            className="absolute bottom-0 left-0"
            src="saturn-assets/images/features/left-blue-center.png"
            alt
          />
          <img
            className="absolute bottom-1/2 right-0 transform translate-y-1/2"
            src="saturn-assets/images/features/orange-right-top.png"
            alt
          />
          <div className="relative container px-4 mx-auto">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-wrap items-center -mx-4">
                <div className="w-full lg:w-1/2 px-4 order-last lg:order-first">
                  <div className="relative pb-20 lg:pb-0">
                    <div className="absolute top-0 left-0 -mt-8 md:mt-9 inline-flex p-4 bg-white rounded-3xl shadow-xl">
                      <div>
                        <img
                          className="rounded-full"
                          src="saturn-assets/images/suzuki.avif"
                          alt="鈴木さん"
                        />
                      </div>
                      <div className="mx-3">
                        <span className="font-semibold">鈴木さんが入室</span>
                        <span className="block text-sm text-gray-500">
                          東京教室 15:40
                        </span>
                      </div>
                      <div className="items-start">
                        <img
                          src="saturn-assets/images/features/check-green.svg"
                          alt
                        />
                      </div>
                    </div>
                    <div className="absolute bottom-0 right-0 max-w-xs lg:-mb-16">
                      <div className="px-6 pt-6 pb-6 lg:pr-16 bg-white rounded-3xl shadow-xl">
                        <div className="inline-flex mb-6">
                          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-200">
                            <img
                              src="saturn-assets/images/features/icon-writing.svg"
                              alt
                            />
                          </div>
                          <div className="mx-3">
                            <span className="text-sm font-semibold">
                              API 連携
                            </span>
                            <span className="block text-xs text-gray-500">
                              お客様の API と連携できます
                            </span>
                          </div>
                        </div>
                        <div className="inline-flex mb-6">
                          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-yellow-200">
                            <img
                              src="saturn-assets/images/features/icon-money-draw.svg"
                              alt
                            />
                          </div>
                          <div className="mx-3">
                            <span className="text-sm font-semibold">
                              クラウドとの接続
                            </span>
                            <span className="block text-xs text-gray-500">
                              お客様のクラウドと連携
                            </span>
                          </div>
                        </div>
                        <div className="inline-flex">
                          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-200">
                            <img
                              src="saturn-assets/images/features/icon-card.svg"
                              alt
                            />
                          </div>
                          <div className="mx-3">
                            <span className="text-sm font-semibold">
                              定額制
                            </span>
                            <span className="block text-xs text-gray-500">
                              どんなに読み込んでも定額
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <img
                      className="mx-auto"
                      src="/saturn-assets/images/feature-1.avif"
                      alt="QRコード読み取り機のイメージ"
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/2 px-4 mb-24 lg:mb-0">
                  <div className="max-w-lg mx-auto lg:mr-0">
                    <span className="inline-block py-1 px-3 mb-4 text-xs font-semibold text-orange-900 bg-orange-50 rounded-full">
                      FEATURES
                    </span>
                    <h1 className="font-heading text-5xl xs:text-6xl font-bold text-gray-900 mb-6">
                      <span>らくらくQRシステムでできること</span>
                    </h1>
                    <p className="text-lg font-semibold mb-6">
                      弊社のエンジニアがお客様の要件をもとに実装
                    </p>
                    <p className="text-gray-400">
                      らくらくQRシステムではすでにメールアドレスの連携が実装されていますが、API
                      を用いた連携やお客様のクラウドとの連携をすることも可能です。ぜひ、お問い合わせください。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}
